import React from "react";

export interface HeadingProps {
  title: string;
  subtitle: string;
}

const Heading = ({ title, subtitle }: HeadingProps) => {
  return <>
    <h1 className="h1 font-hkgrotesk mb-6">
      {title}
    </h1>
    <p className="text-xl text-lucid-300 mb-10">
      {subtitle}
    </p>
  </>;
};

export default Heading;
